var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enigma-container"},[_c('overlay-navigation',{staticClass:"absolute w-full h-full",attrs:{"hide-info":true}}),_c('text-mystery',{attrs:{"background-id":'1',"id":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }